<form class="form" id="attendeesNotes" (ngSubmit)="onSubmit()" #attendeesNotes="ngForm">
    <!-- Filter -->
    <div class="row mb-2">
        <div class="col-lg-6 mb-2">
            <ngx-select
                [allowClear]="true"
                [items]="eventsForDropdown"
                (select)="changeFilter('eventId', $event)"
                (remove)="changeFilter('eventId', null)"
                [placeholder]="'FILTER.EVENTS.PLACEHOLDER' | translate">
            </ngx-select>
        </div>
        <div class="col-lg-6 mb-2">
            <ngx-select
                [allowClear]="true"
                [items]="itemsTaskStatusTypes"
                (select)="changeFilter('taskStatusType', $event)"
                (remove)="changeFilter('taskStatusType', 0)"
                [placeholder]="'FILTER.TASKSTATUSTYPE.PLACEHOLDER' | translate">
            </ngx-select>
        </div>
    </div>
    <!-- Datatable -->
    <ngx-datatable
        #table
        class="material striped"
        [columnMode]="'force'"
        [headerHeight]="50"
        [footerHeight]="'auto'"
        [rowHeight]="50"
        [limit]="10"
        [rows]="attendeesNotesList"
        [messages]="{emptyMessage: 'DATATABLE.EMPTYMESSAGE.TASKS.TITLE' | translate}"
        [loadingIndicator]="loadingIndicator">
        <ngx-datatable-column name="eventName">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span [innerHtml]="'DATATABLE.COLUMN.EVENT.TITLE' | translate" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ row?.event?.name }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="attendeeName">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span [innerHtml]="'DATATABLE.COLUMN.ATTENDEE.TITLE' | translate" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ row?.attendee?.firstName }}{{ tenantSettings?.lastNamePrefixPermission && row?.attendee?.lastNamePrefix ? ' ' + row?.attendee?.lastNamePrefix : '' }} {{ row?.attendee?.lastName }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="dueDate">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span [innerHtml]="'DATATABLE.COLUMN.DUEDATE.TITLE' | translate" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ row?.dueDate | amLocale: locale | amDateFormat: 'L LT' }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="taskStatusType">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span [innerHtml]="'DATATABLE.COLUMN.TASKTYPE.TITLE' | translate" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span>{{ 'TASKSTATUSTYPE.' + row?.taskStatusType | translate }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="taskValue">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span [innerHtml]="'DATATABLE.COLUMN.TASKVALUE.TITLE' | translate" (click)="sort()"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <span [title]="row?.value">{{ row?.value }}</span>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="isCompleted" [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
            <ng-template let-column="column" ngx-datatable-header-template>
                <span [innerHtml]="'DATATABLE.COLUMN.ISCOMPLETED.TITLE' | translate"></span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template>
                <div class="custom-checkbox">
                    <input id="{{'checkbox-' + row?.id}}"
                           type="checkbox"
                           [checked]="row?.isCompleted"
                           (change)="onCheckboxChange($event, row?.id)"/>
                    <label for="{{'checkbox-' + row?.id}}"></label>
                </div>
            </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-footer>
            <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-curPage="curPage"
                let-isVisible="isVisible">
                <div class="pl-2 pt-2">
                    <span>
                        {{ rowCount }} {{ ((rowCount === 1) ? ('DATATABLE.FOOTER.TASKS.SINGLE.LABEL' | translate) : ('DATATABLE.FOOTER.TASKS.MULTIPLE.LABEL' | translate)) }}
                    </span>
                </div>
                <datatable-pager
                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                    [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'"
                    [pagerNextIcon]="'datatable-icon-skip'"
                    [page]="curPage"
                    [size]="pageSize"
                    [count]="rowCount"
                    [hidden]="!((rowCount / pageSize) > 1)"
                    (change)="table.onFooterPage($event)">
                </datatable-pager>
            </ng-template>
        </ngx-datatable-footer>
    </ngx-datatable>
</form>
